module.exports = __webpack_public_path__ + "static/media/producing_asset_2.f1342ce3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/producing_asset_2.jpg
// module id = 1854
// module chunks = 0